import { useNavigate } from "react-router-dom";
import ButtonContainer from "../../components/buttonContainer";
import SectionWrapper from "../../components/sectionWrapper";
import TailoringAndDryClean from "./tailoringAndDryClean";
import WashAndFold from "./washAndFold";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "../../../../component/SnackbarContext";
import {
  getServiceEstimate,
  storePayload,
} from "../../../../utils/storePayload";
import { setShopDetails } from "../../../../Redux/Slices/customerSlice";

const AddToCart = () => {
  const {
    orderFlow,
    selectedShop,
    selectedService,
    cartItems,
    payloadAddress,
    pickupDetails,
  } = useSelector((state) => state.customer);
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const dispatch = useDispatch();

  const previousHandler = () => {
    navigate("/pickup-details");
  };
 
  const nextHandler = () => {
      if (!cartItems || cartItems?.length === 0) {
    showSnackbar("Your cart is empty. Please add your services before proceeding.", "error");
    return;
  }

  const isValidCart = cartItems.every((item) => {
    if (!item.weight || Number(item.weight) <= 0) {
      showSnackbar(
        `Weight is missing in "${item?.name}"`,
        "error"
      );
      return false;
    }
    if (selectedService === "Dry Cleaning") {
      if (!item.category || item.category.trim() === "") {
        showSnackbar(
          `Category is missing for "${item.name}"`,
          "error"
        );
        return false;
      }
    }

    // Tailoring extra checks
    if (selectedService === "Tailoring") {
      if (!item.category || item.category.trim() === "") {
        showSnackbar(
          `Category is missing for "${item.name}"`,
          "error"
        );
        return false;
      }
      if (!Array.isArray(item.tailoringType) || item.tailoringType.length === 0) {
        showSnackbar(
          `At least one tailoring type is required for "${item.name}"`,
          "error"
        );
        return false;
      }
    }

    return true;
  });

  if (!isValidCart) return;

  if (orderFlow === "shop") {
    const payload = storePayload(
      cartItems,
      pickupDetails,
      payloadAddress,
      selectedService
    );

    getServiceEstimate(payload, selectedService)
      .then((mappedShops) => {
        const matchedShop = mappedShops.find(
          (shop) => shop.id === selectedShop.id
        );
        if (matchedShop) {
          dispatch(setShopDetails(matchedShop));
        } else {
          showSnackbar("Something went wrong!", "error");
        }
        navigate("/review-place-order");
      })
      .catch(() => showSnackbar("Something went wrong!", "error"));
  } else {
    navigate("/shop-selection");
  }
};


  return (
    <SectionWrapper
      title="Your clothes deserve the best –"
      subTitle="pick now!"
    >
      <div className="w-full px-3 lgs:px-4 lg:px-6 xl:px-8">
        <div className="mb-3">
          <ButtonContainer
            handleNext={nextHandler}
            handlePrevious={previousHandler}
          />
        </div>

        <div className="w-full ">
          {selectedService === "Wash & Fold" ? (
            <WashAndFold />
          ) : (
            <TailoringAndDryClean />
          )}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default AddToCart;
